var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { attrs: { id: "app" } },
    [
      _c("router-view", { key: _vm.$route.fullPath }),
      [
        _c("cookies-view", {
          attrs: { "open-window": _vm.openWindow },
          on: { closeDetails: _vm.closeDetailsWindow }
        })
      ],
      _c("footer-cookies-view", {
        class: { "footer-cookies--open": _vm.openCookiesFooter },
        on: { openDetails: _vm.openDetailsWindow, closeFooter: _vm.closeFooter }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 142
// module chunks = 18